import CookieDefinitions from "../definitions/cookie-definitions";
import UXDefinitions from "../definitions/ux-definitions";

export const COOKIE_VERSION = "1";

export const DEFAULT_COOKIE_AGE = 31536000;

// 68 years in seconds for the permanent cookie (to prevent integer overflow in 32-bit systems)
export const PERMANENT_COOKIE_AGE = 68 * 365 * 24 * 60 * 60;

// Name of the permanent cookie for long-lasting preferences
export const PERMANENT_COOKIE_NAME = "awscccp";

export const DEFAULT_COOKIE: CookieDefinitions.ConsentCookie = {
  essential: true,
  functional: false,
  performance: false,
  advertising: false,
  ccba: true,
};

export const ALL_ALLOWED: CookieDefinitions.ConsentCookie = {
  essential: true,
  functional: true,
  performance: true,
  advertising: true,
  ccba: true
};

export const DEFAULT_LANGUAGE: UXDefinitions.LanguageCodesNormalized = "en-us";

export const DEFAULT_DOMAIN = ".aws.amazon.com";

export const DEFAULT_NEW_AWS_DOMAIN = ".aws.com";

export const DEFAULT_TANGERINEBOX_DEV_DOMAIN = ".aws-dev.amazon.com";

export const DEFAULT_DOMAIN_ESC = ".amazonaws-eusc.eu";

export const CONSENT_COOKIE_CHANGED_EVENT = "cookie-consent-changed";

export const COOKIE_CHANGE_EVENT = "cookieChangeEvent";

export const ESC_REGIONS = ["eusc-de-east-1"];
